import React from 'react';
import {motion} from 'framer-motion';

const CostOfInaction=({openCheckoutPopup})=> {
  const costs=[
    {icon: "📅", text: "Another festive season gone without results."},
    {icon: "🏃‍♂️", text: "Competitors grabbing your customers."},
    {icon: "😰", text: "Lost leads, missed profits, sleepless nights."}
  ];

  return (
    <section className="py-16 bg-red-50">
      <div className="container mx-auto px-4">
        <motion.div 
          className="text-center mb-12"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8">
            Still Thinking? Here's What It's <span className="text-red-500">Costing You</span>… 💔
          </h2>
          
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            {costs.map((cost, index)=> (
              <motion.div
                key={index}
                className="bg-white p-6 rounded-2xl shadow-lg text-center"
                initial={{opacity: 0, y: 30}}
                whileInView={{opacity: 1, y: 0}}
                transition={{duration: 0.6, delay: index * 0.1}}
                viewport={{once: true}}
              >
                <div className="text-4xl mb-4">{cost.icon}</div>
                <p className="text-lg text-gray-700 font-medium">{cost.text}</p>
              </motion.div>
            ))}
          </div>

          <motion.div 
            className="bg-gradient-to-r from-red-500 to-orange-500 text-white p-8 rounded-2xl"
            initial={{opacity: 0, scale: 0.9}}
            whileInView={{opacity: 1, scale: 1}}
            transition={{duration: 0.6, delay: 0.4}}
            viewport={{once: true}}
          >
            <p className="text-2xl font-bold mb-4">
              Don't let this Diwali be another regret — take action now. 🎯
            </p>
            <button 
              onClick={openCheckoutPopup}
              className="bg-white text-red-500 px-8 py-3 rounded-xl font-bold hover:bg-gray-100 transition-colors"
            >
              I'm Ready to Take Action →
            </button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default CostOfInaction;